import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import CpfComponent from '../../components/Cpf';
import LogoText from '../../components/LogoText/LogoText';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import { isSignUp, pushGtmEvent } from '../../utils/GenericFunctions';
import { sendSocialData } from '../../services/socialNetWorkController';

export interface CpfPageProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
  viewSuccess?: any;
}

export default function CpfPage({
  nextPath,
  handleChangeStep,
  previousPath,
  context
}: CpfPageProps) {
  const {
    register,
    watch,
    errors,
    originDomainForm,
    setValue,
    touchedFields,
    handleSubmit,
    submitForm
  } = useContext<any>(context);
  const [fieldValidate, setValueValidateField] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    socialWithoutEmail,
    socialData,
    providerSocial,
    tokenSocial,
    notCreateAccount,
    showErrorMessageServer,
    setNotCreateAccount
  } = useControllerFlowStepsContext();
  const url = `/${originDomainForm}/cadastro-cpf`;
  const navigate = useNavigate();

  useEffect(() => {
    pushGtmEvent('cpf_step_exibida');
    setNotCreateAccount(false);
  }, []);

  useEffect(() => {
    if (errors.cpf) pushGtmEvent('cpf_erro_validacao');
  }, [errors.cpf]);

  useEffect(() => {
    navigate(url);
  }, [navigate]);

  window.onpopstate = () => {
    controlBackPage();
  };

  function controlBackPage() {
    if (previousPath == 0 || previousPath) {
      handleChangeStep(previousPath);
    }
  }

  useEffect(() => {
    const subscription = watch((data: any) => {
      setValueValidateField(data.cpf);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  async function createAccount() {
    if (providerSocial) {
      setValue('isSocial', true);
      setValue('provider', providerSocial);
      if (socialData.email) setValue('email', socialData.email);

      await handleSubmit(
        async (data: any) => await submitForm(data, nextStep, providerSocial)
      )();
    } else {
      await handleSubmit(
        async (data: any) => await submitForm(data, nextStep)
      )();
    }
  }

  async function sendSocialToken() {
    const token = tokenSocial;
    try {
      const resp = await sendSocialData(token, providerSocial);
      setValue('isSocial', true);
      setValue('provider', providerSocial);
      if (resp.email) setValue('email', resp.email);
      await handleSubmit(
        async (data: any) => await submitForm(data, nextStep, providerSocial)
      )();
    } catch (error: any) {
      console.log(error);
      showErrorMessageServer();
    }
  }

  async function checkExistsAccountWithCpf() {
    setLoading(true);
    try {
      pushGtmEvent('cpf_informado_sucesso');
      if (notCreateAccount && !socialWithoutEmail) nextStep();
      else if (socialWithoutEmail) await sendSocialToken();
      else await createAccount();
    } catch (e) {
      console.log(e);
      showErrorMessageServer();
    } finally {
      setLoading(false);
    }
  }

  function nextStep() {
    if (nextPath) {
      handleChangeStep(nextPath);
    }
    setLoading(false);
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <LogoText />
        <h2 className="color-text-default">
          {isSignUp(originDomainForm) ? 'criar conta' : 'complete seus dados'}
        </h2>
        <span className="md mt-4 color-text-default">
          Informe seus dados para completar sua Conta SBT
        </span>

        <div className="flex flex-column mt-16">
          <CpfComponent
            errors={errors}
            touchedFields={touchedFields}
            register={register}
            name={'cpf'}
          />
        </div>
      </div>
      <div>
        <Button
          className="mt-8"
          full
          onClick={checkExistsAccountWithCpf}
          loading={loading}
          disabled={!!errors.cpf || !fieldValidate.length || loading}
        >
          <ButtonLabel loading={loading}>avançar</ButtonLabel>
        </Button>
      </div>
    </div>
  );
}
